import { useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/shared/components/ui/dialog';
import { RippleButton } from '@/shared/components/AnimateUi/RippleButton';

export function PwaUpdateModal() {
  const [isLoading, setIsLoading] = useState(false);
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  const handleReload = async () => {
    setIsLoading(true);
    await updateServiceWorker(true);
  };

  return (
    <Dialog open={needRefresh} onOpenChange={() => {}}>
      <DialogContent
        hideCloseButton
        onPointerDownOutside={e => e.preventDefault()}
        onEscapeKeyDown={e => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Update Available</DialogTitle>
          <DialogDescription>
            A new version of the application is available. Please reload to update.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-center">
          <RippleButton
            onClick={handleReload}
            loading={isLoading}
            className="w-full focus-visible:ring-0 focus-visible:ring-offset-0"
          >
            Reload
          </RippleButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
